import React from "react";
import "./style.css";

const Modal = ({ isOpen, onClose, title, children, id = "modal" }) => {
  if (!isOpen) return null;

  return (
    <div className="overlay" onClick={onClose}>
      <div
        className="modal"
        id={id}
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-label={title || "Modal"}
      >
        <button className="modal__close" onClick={onClose} aria-label="Close">
          ✕
        </button>

        {title ? <div className="modal__subtitle">{title}</div> : null}

        {children}
      </div>
    </div>
  );
};

export default Modal;
